module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tree-panel"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n    Tree\n    "), _c('user-select', {
    attrs: {
      "model": _vm.treePanel,
      "prop": "selectedUser",
      "add-all-option": false
    }
  })], 1), _vm._v(" "), _c('tree-panel-filter'), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), (_vm.subtreeFilter) ? _c('div', {
    staticClass: "subtree-filter"
  }, [_c('infobit', {
    attrs: {
      "infobit": _vm.subtree.infobit
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "clickable",
    on: {
      "click": _vm.resetSubtreeFilter
    }
  }, [_vm._v("Reset")])], 1) : _vm._e(), _vm._v(" "), (_vm.subtree) ? _c('infobits-tree', {
    attrs: {
      "tree": _vm.subtree
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isTreeEmpty) ? _c('div', {
    directives: [{
      name: "dragula",
      rawName: "v-dragula",
      value: ([]),
      expression: "[]"
    }],
    staticClass: "empty-tree-drop-area",
    attrs: {
      "bag": "infobits"
    }
  }, [_vm._v("\n    Drop infobits from the inbox here\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32a26c2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tree-panel.vue
// module id = 139
// module chunks = 0